export default __webpack_public_path__ + "images/MA.620ed83.png";